<script setup lang="ts">
import QuestionnaireColorIcon from "@/components/QuestionnaireColorIcon.vue";
import type { Questionnaire, QuestionnaireWithResponses } from "@/types";

export type FilterCriteria = {
  questionnaireIds: Questionnaire["id"][];
};

const filterCriteria = defineModel<FilterCriteria>({ required: true });

const { questionnaires } = defineProps<{
  questionnaires: QuestionnaireWithResponses[];
}>();

function onToggle(id: Questionnaire["id"]) {
  const selected = filterCriteria.value.questionnaireIds;

  filterCriteria.value.questionnaireIds = selected.includes(id)
    ? selected.filter((questionnaireId) => questionnaireId !== id)
    : [...selected, id];
}
</script>

<template>
  <fieldset>
    <legend class="col-form-label pt-0 fw-semibold">Spørgeskemaer</legend>
    <div
      v-for="questionnaire in questionnaires"
      :key="questionnaire.id"
      class="form-check d-flex gap-2"
    >
      <input
        :id="`questionnaire-responses-filter-${questionnaire.id}`"
        class="form-check-input"
        type="checkbox"
        :value="questionnaire.id"
        :checked="filterCriteria.questionnaireIds.includes(questionnaire.id)"
        :disabled="questionnaire.responses.length === 0"
        @change="onToggle(questionnaire.id)"
      />
      <label
        class="form-check-label d-inline-flex gap-1"
        :for="`questionnaire-responses-filter-${questionnaire.id}`"
      >
        <QuestionnaireColorIcon
          class="flex-shrink-0 mt-1"
          :color="questionnaire.color"
        />
        <span>
          {{ questionnaire.name }}
          <small
            v-if="
              questionnaire.responses.length === 0 &&
              questionnaire.hasOlderResponses
            "
            class="d-block text-body-secondary"
          >
            Ingen registreringer de seneste 24 måneder
          </small>
          <small
            v-else-if="
              questionnaire.responses.length === 0 && questionnaire.manual
            "
            class="d-block text-body-secondary"
          >
            Manuelt registreret – data deles ikke via KIH-databasen
          </small>
        </span>
      </label>
    </div>
  </fieldset>
</template>
